import { useState, useEffect } from "react";
import axios from "axios";
import { useGetQuery } from "./useGetQuery";
import { setValueToNone } from "../lib/setValueToNone";
import { FETCH_KYC } from "../globals";

export const useKyc = () => {
  const [kyc, setKyc] = useState({});
  const [loading, setLoading] = useState(false);

  const {
    parsedData: { address },
  } = useGetQuery();
  const id = address && JSON.parse(address).user.id;

  useEffect(() => {
    (async () => {
      if (id) {
        setLoading((s) => !s);
        try {
          let res = await axios.get(`${FETCH_KYC}/getSpecific/${id}`);

          if (res.data.data && res.data.data.Items[0]) {
            const newObj = setValueToNone(res.data.data.Items[0]);
            setKyc(newObj);
          }
        } catch (error) {
          console.error("Error: ", error);
        }
        setLoading((s) => !s);
      }
    })();
  }, [id]);

  return { kyc, loading };
};
